(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name cookieController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('cookieController', cookieController);
    cookieController.$inject = ["$scope","$timeout","$http"];

    function cookieController($scope,$timeout,$http){
         
        var vm = this;
		vm.personalizacion = false;
		vm.analityc = false;
		vm.showCookie = true;
        
        vm.rechazarTodas = function()
        {
        	vm.personalizacion = false;
			vm.analityc = false;
            vm.sendCookie();
        }

        vm.sendCookie = function()
        {
        	
            vm.updateGtag();
        	return $http.get('/ajax/yescoc',{
    			params: { 
    				personalizacion: vm.personalizacion,
    				analityc: vm.analityc,
    			}
			})
            .then(function(data){
            	console.log(data);
            	vm.showCookie = false;
                return data.data;
            },function(data){
                return data;
            });

        }

        vm.updateGtag = function()
        {
            if(gtag)
                gtag('consent', 'update', {
                    analytics_storage: (vm.analityc)?'granted':'denied',
                    functionality_storage: 'granted',
                    personalization_storage: (vm.personalizacion)?'granted':'denied'
                });
        }

        vm.aceptarTodas = function()
        {
        	vm.personalizacion = true;
			vm.analityc = true;
            
        
			vm.sendCookie();

        }


        
    }    

    })();